export const wrapper = () => ({
    backgroundImage: 'linear-gradient(109.88deg, #ffffff 2.53%, #fafafa 68.99%, #f1f1f1 83.23%, #d1f1e4 97.47%)',
    minHeight: '573px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',
});

export const inner = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '30px',
    paddingTop: '80px',
    paddingBottom: '80px',
    paddingLeft: '24px',
    paddingRight: '24px',
    width: '100%',
    margin: '0 auto',
    min1200px: {
        paddingLeft: 0,
        paddingRight: 0,
    },
});

export const title = ({ theme }) => ({
    maxWidth: '1240px',
    fontFamily: theme.fontFamily,
    fontWeight: 800,
    fontSize: '36px',
    lineHeight: '42px',
    letterSpacing: '-1px',
    color: theme.colors.greyDarkest,
    margin: 0,
    min768px: {
        fontSize: '46px',
        lineHeight: '52px',
        letterSpacing: '-1.2px',
    },
    min992px: {
        fontSize: '54px',
        lineHeight: '62px',
        letterSpacing: '-1.4px',
    },
});

export const subtitle = ({ theme }) => ({
    fontFamily: theme.fontFamily,
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: 1.5,
    letterSpacing: '0.36px',
    color: theme.colors.black,
    margin: 0,
    maxWidth: '960px',
    min768px: {
        fontSize: '22px',
    },
    min992px: {
        fontSize: '30px',
    },
});
